module.exports = __webpack_public_path__ + "img/knu2_gallery2.4422ab4b.jpg";